import React, { useState } from 'react';
import { makeStyles } from "@mui/styles";
import { Dialog, DialogActions, DialogContent, DialogTitle, TextField, InputAdornment } from '@mui/material';
import { Button } from '@mui/material';
import FlagstoneTheme from '../../../Config/flagstoneTheme';
import { dataService } from '../../../Services/data/data.service'

import { useTranslation } from 'react-i18next';

import { ScanBarcode, ScanFace, X, LoaderCircle } from 'lucide-react';



export default function AuthenticationDialog(props) {

    const classes = useStyles();
    const { t } = useTranslation();
    const [badgeNumber, setBadgeNumber] = useState("");
    const [authenticationFeedback, setAuthenticationFeedback] = useState(null);
    const [feedbackText, setFeedbackText] = useState(null);
    const [isShaking, setIsShaking] = useState(false)
    const [authenticating, setAuthenticating] = useState(false);

    const changeBadgeNumber = (value) => {
        var tempBadgeNumber = value.target.value;
        setBadgeNumber(tempBadgeNumber);
    }

    const _handleKeyDownBadgeNumber = (e) => {
        //Handle if enter
        if (e.key === 'Enter') {
            handleAuthentication();
        }
    }

    const authenticated = (userId) => {
        props.authenticateAndTriggerAction(userId);
        props.closeAuthenticationDialog();
    }

    const handleAuthentication = () => {
        if (!authenticating) {
            setAuthenticating(true);
            //Authenticate the user by badgeNumber
            dataService.validateCredentials(badgeNumber).then(result => {
                if (result !== null && result !== undefined && result.ok) {
                    setAuthenticationFeedback(result.data.Succeeded);
                    if (!result.data.Succeeded) {
                        setIsShaking(true);
                        setAuthenticating(false);
                        setTimeout(() => setIsShaking(false), 1000); // Stop shaking after 1 second

                        setFeedbackText(t("Invalid badgenumber, try again."));
                        setBadgeNumber("");
                    } else {
                        setFeedbackText("");
                        props.setUserId(result.data.Results[0].UserId);
                        if(result.data.Results[0].Success)
                        {
                            setTimeout(() => authenticated(result.data.Results[0].UserId), 500);
                        } else {
                            setIsShaking(true);
                            setAuthenticating(false);
                            setTimeout(() => setIsShaking(false), 1000); // Stop shaking after 1 second

                            setFeedbackText(t("Invalid badgenumber, try again."));
                            setBadgeNumber("");
                        } 
                    }
                } else {
                    setIsShaking(true);
                    setTimeout(() => setIsShaking(false), 1000); // Stop shaking after 1 second

                    setAuthenticationFeedback(false);
                    setFeedbackText(t("Invalid badgenumber, try again."));
                }
            });
        }
    }

    return (
        <Dialog className={classes.dialogContainer}
            open={props.dialogOpen}
            onClose={props.closeDialog}

            classes={{ paper: classes.dialogPaper }}

            aria-labelledby="draggable-dialog-title"
        >
            <div className={classes.dialog__head}>
                <DialogTitle className={classes.dialog__title} id="draggable-dialog-title">
                    {t('Authenticate')}
                </DialogTitle>
                <button onClick={() => props.closeAuthenticationDialog()} className={classes.dialog__closeButton}>
                    <X size={19} />
                </button>
            </div>
            <DialogContent className={classes.dialog__contentContainer}>
                <div className={classes.dialog__authenticationContainer}>
                    <ScanFace className={isShaking ? 'shake' : ''}
                        size={96} strokeWidth={4} absoluteStrokeWidth style={{ color: authenticationFeedback !== null && authenticationFeedback ? 'rgb(92, 201, 88)' : ((authenticationFeedback !== null && !authenticationFeedback) ? 'rgb(216, 73, 73)' : 'black') }} />
                    <div className={classes.dialog__input}>
                        <label className={classes.dialog__label}>{t('Badgenummer')}</label>
                        <TextField
                            id="outlined-search"
                            className={classes.dialog__inputfield}
                            size="small"
                            variant="outlined"
                            value={badgeNumber}
                            autoFocus
                            style={{
                                background: authenticationFeedback !== null && authenticationFeedback ? 'rgba(92, 201, 88, 0.1)' : ((authenticationFeedback !== null && !authenticationFeedback) ? 'rgb(255, 0, 0, 0.2)' : 'none'),
                                boxShadow: authenticationFeedback !== null && authenticationFeedback ? 'rgb(92, 201, 88) 0px 0px 7px' : ((authenticationFeedback !== null && !authenticationFeedback) ? 'rgb(216, 73, 73) 0px 0px 7px' : 'none'),
                            }}
                            onChange={(e) => changeBadgeNumber(e)}
                            onKeyDown={(e) => _handleKeyDownBadgeNumber(e)}
                            InputProps={{
                                style: {
                                    height: '40px',
                                    fontFamily: "Lato, sans-serif",
                                    fontSize: '16px',
                                    color: '#0C0E29',
                                },
                                endAdornment: <InputAdornment position="end"><ScanBarcode size={24} color='#0C0E29' /></InputAdornment>,
                            }}>
                        </TextField>
                        <div className={classes.dialog__feedback}>
                            {feedbackText}
                        </div>
                    </div>
                </div>

                {/* <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', paddingTop: '50px', minWidth: '460px' }}>
                    <Typography sx={{
                        color: "#606060",
                        fontSize: "14px",
                        fontFamily: "Lato, sans-serif",
                    }}>{t('Badgenummer')}
                    </Typography>
                    <TextField
                        id="outlined-search"
                        className={classes.uiTextField}
                        size="small"
                        variant="outlined"
                        value={badgeNumber}
                        autoFocus
                        style={{
                            background: authenticationFeedback !== null && authenticationFeedback ? 'rgba(92, 201, 88, 0.1)' : ((authenticationFeedback !== null && !authenticationFeedback) ? 'rgb(255, 0, 0, 0.2)' : 'none'),
                            boxShadow: authenticationFeedback !== null && authenticationFeedback ? 'rgb(92, 201, 88) 0px 0px 7px' : ((authenticationFeedback !== null && !authenticationFeedback) ? 'rgb(216, 73, 73) 0px 0px 7px' : 'none'),
                        }}
                        onChange={(e) => changeBadgeNumber(e)}
                        onKeyDown={(e) => _handleKeyDownBadgeNumber(e)}
                        InputProps={{
                            endAdornment: <InputAdornment position="end"><BiBarcode /></InputAdornment>,
                        }}>
                    </TextField>
                    <div className={classes.resultText}>
                        {feedbackText}
                    </div>
                </Box> */}

            </DialogContent>
            <DialogActions className={classes.dialog__buttonContainer}>
                <Button className={classes.dialog__button__secondary} onClick={() => props.closeAuthenticationDialog()}>
                    {t('Back')}
                </Button>
                <button className={`${classes.dialog__button} ${authenticating ? classes.dialog__button_loading : ""}`} disabled={badgeNumber === null || badgeNumber === ""} onClick={() => handleAuthentication()}>
                    {authenticating && <div className={classes.button__loader}><LoaderCircle className={classes.button__loader__spinner} /></div>}
                    {t('Print')}
                </button>
            </DialogActions>
        </Dialog>
    );
}

const useStyles = makeStyles(() => ({

    dialog: {
        // width: "720px !important",
        // height: "384px !important",
        margin: "auto"
    },


    dialogPaper: {
        minWidth: '300px',
        minHeight: '375px',
        width: '300px !important',
        height: '375px !important',
        borderRadius: '6px',
    },

    dialog__head: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',

        padding: '16px 16px 0px 16px !important',
        marginBottom: '8px !important',
    },

    dialog__title: {
        fontSize: '24px !important',
        fontFamily: "Lato, sans-serif !important",
        fontWeight: 'normal',

        padding: '0px !important',
    },

    dialog__closeButton: {
        backgroundColor: '#F5F5F5',
        border: 'none',
        cursor: 'pointer',

        padding: '3px !important',
        height: '25px !important',

        borderRadius: '3px',

        transition: 'backgroundColor 0.2s, color 0.2s',

        '&:hover': {
            backgroundColor: '#D84949',
            color: '#F5F5F5',
        },

        '&:focus': {
            outline: '#4654FB auto 1px',
        },

    },

    dialog__contentContainer: {
        padding: '0px 16px !important',

        // remove scrollbar
        '&::-webkit-scrollbar': {
            display: 'none',
        },
        '-ms-overflow-style': 'none',
        scrollbarWidth: 'none',

    },

    dialog__authenticationContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        gap: '24px',
    },

    dialog__input: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
    },

    dialog__label: {
        fontSize: '16px',
        fontFamily: "Lato, sans-serif",
        fontWeight: 'normal',
        color: '#0C0E29',
    },

    dialog__inputfield: {
        width: '100%',
        height: '40px !important',
        padding: '0px !important',
    },

    dialog__feedback: {
        width: '100%',
        height: '18px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: FlagstoneTheme.palette.error.main,


        fontSize: '14px',
        fontFamily: "Lato, sans-serif",
        fontWeight: '500',
    },

    dialog__buttonContainer: {
        width: '100%',
        boxSizing: 'border-box',

        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between !important',

        padding: '16px !important',
        paddingTop: '0px !important',
        margin: '0px !important',
    },

    dialog__button: {
        color: "white !important",
        fontSize: "16px !important",
        fontWeight: "bold !important",
        fontFamily: "Lato, sans-serif !important",
        backgroundColor: FlagstoneTheme.palette.primary.main + " !important",
        border: "none !important",
        borderRadius: "3px !important",
        minWidth: "fit-content !important",
        height: '40px !important',
        padding: '0px 20px !important',
        textTransform: 'none !important',
        position: 'relative !important',

        transition: 'all 0.2s !important',

        '&:hover': {
            backgroundColor: "#3B3AF1 !important",
            color: "white !important",
            cursor: "pointer !important",
        },
        '&:disabled': {
            backgroundColor: "lightgrey !important",
            color: "white !important",
            border: "1px solid darkgrey !important",
            cursor: "not-allowed !important"
        },
    },

    dialog__button_loading: {
        backgroundColor: "#C3D3FF !important",
        color: "#C3D3FF !important",

        '&:hover': {
            backgroundColor: "#C3D3FF !important",
            color: "#C3D3FF !important",
            cursor: "default !important",
        },
    },

    button__loader: {
        width: "24px",
        height: "24px",
        color: FlagstoneTheme.palette.primary.main,

        position: "absolute",
        display: "block",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
    },

    button__loader__spinner: {
        width: "100%",
        height: "100%",

        animation: "spin 1s linear infinite",
    },

    '@global': {
        '@keyframes spin': {
            '0%': {
                transform: 'rotate(0deg)',
            },
            '100%': {
                transform: 'rotate(360deg)',
            },
        },
    },

    dialog__button__secondary: {
        color: FlagstoneTheme.palette.primary.main + " !important",
        fontSize: "16px !important",
        fontWeight: "bold !important",
        fontFamily: "Lato, sans-serif !important",
        backgroundColor: "white !important",
        border: "1px solid " + FlagstoneTheme.palette.primary.main + " !important",
        minWidth: "fit-content !important",
        height: '40px !important',
        padding: '0px 20px !important',
        textTransform: 'capitalize !important',

        '&:hover': {
            backgroundColor: FlagstoneTheme.palette.primary.main + " !important",
            color: "white !important",
            border: "1px solid " + FlagstoneTheme.palette.primary.main + " !important",
        },
        '&:disabled': {
            backgroundColor: "lightgrey !important",
            color: "white !important",
            border: "1px solid darkgrey !important",
            cursor: "not-allowed !important"
        },
    },

    dialogContainer: {
        width: "520px !important",
        height: "420px !important",
        margin: "auto"
    },
    buttons: {
        textAlign: "center"
    },
    okButton: {
        color: "white",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        backgroundColor: FlagstoneTheme.palette.primary.main + ' !important',
        '&:hover': {
            backgroundColor: "white !important",
            color: FlagstoneTheme.palette.primary.main,
            border: "1px solid " + FlagstoneTheme.palette.primary.main,
        },
        border: "1px solid " + FlagstoneTheme.palette.primary.main + ' !important'
    },

    action2Button: {
        color: FlagstoneTheme.palette.primary.main + ' !important',
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        '&:hover': {
            backgroundColor: FlagstoneTheme.palette.primary.main + " !important",
            color: 'white !important'
        },
        border: "1px solid " + FlagstoneTheme.palette.primary.main + " !important",
        marginRight: '15px !important',
        width: "max-content",
        maxWidth: "200px",
    },
    dialogTitle: {
        color: "#000000",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center",
        '& h2': {
            fontSize: "32px !important",
        },
        minWidth: '460px',
        paddingTop: "20px",
    }, resultText: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: FlagstoneTheme.palette.error.main,
        fontWeight: '500',
        height: '50px',
        marginTop: '10px',
        width: '100%'
    },
    dialogContext: {
        color: "#000000",
        fontSize: "18px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center"
    }
}));
